<mat-form-field [hideRequiredMarker]="hideRequiredMarker()">
  <mat-label>{{ label() | translate }}</mat-label>
  <input
    [autocomplete]="autocomplete()"
    [formControl]="accessorDirective.control"
    [type]="type()"
    matInput
    placeholder="{{ placeholder() | translate }}" />
  @if (hint()) {
    <mat-hint>
      {{ hint() | translate }}
    </mat-hint>
  }

  @if (errors()?.length > 0) {
    <mat-error class="error">
      @for (error of errors(); track error) {
        @if (
          accessorDirective.control.invalid &&
          (accessorDirective.control.dirty || accessorDirective.control.touched) &&
          accessorDirective.control.hasError(error.errorCode)
        ) {
          <span class="error-text">
            {{ error.errorMessage | translate }}
          </span>
        }
      }
    </mat-error>
  }
</mat-form-field>
